import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

// YOUR LAST 8 SEARCHES (Search S3, G14) — kept on THIS device for whoever is signed in (his call, 25 Oct):
// nothing about who searched what is stored on the server. One list for Find a Part, All Parts and Vehicles.
const MAX = 8;
const keyFor = (user) => `fas.recent.v1.${user?.id || user?.email || "anon"}`;

function read(key) {
  try { const v = JSON.parse(localStorage.getItem(key) || "[]"); return Array.isArray(v) ? v.filter((x) => typeof x === "string") : []; }
  catch { return []; }
}

export function useRecentSearches() {
  const { user } = useAuth();
  const key = keyFor(user);
  const [items, setItems] = useState(() => read(key));
  useEffect(() => { setItems(read(key)); }, [key]);
  useEffect(() => {
    const onStore = (e) => { if (e.key === key) setItems(read(key)); };
    window.addEventListener("storage", onStore);
    return () => window.removeEventListener("storage", onStore);
  }, [key]);
  const save = useCallback((next) => { setItems(next); try { localStorage.setItem(key, JSON.stringify(next)); } catch { /* full */ } }, [key]);
  const add = useCallback((q) => {
    const v = String(q || "").trim().slice(0, 60);
    if (v.length < 2 || !user) return;
    const cur = read(key);
    save([v, ...cur.filter((x) => x.toLowerCase() !== v.toLowerCase())].slice(0, MAX));
  }, [key, save, user]);
  const remove = useCallback((q) => {
    const cur = read(key);
    const at = cur.indexOf(q);
    if (at < 0) return;
    save(cur.filter((x) => x !== q));
    // undo instead of "are you sure?"
    toast(`Removed “${q}” from your recent searches`, { action: { label: "Undo", onClick: () => {
      const now = read(key).filter((x) => x !== q);
      now.splice(Math.min(at, now.length), 0, q);
      save(now.slice(0, MAX));
    } } });
  }, [key, save]);
  return { items, add, remove };
}
